import { query } from '@confluence/query-preloader-tools';
import { BreadcrumbsQuery } from '@confluence/breadcrumbs-utils/entry-points/BreadcrumbsQuery.graphql';
import { expVal } from '@confluence/feature-experiments';

export function preloadBreadcrumbs(spaceKey, contentId, skipContent = false) {
	if (expVal('confluence_unified_space_preloader', 'isEnabled', false)) {
		return Promise.resolve();
	}
	return query({
		query: BreadcrumbsQuery,
		variables: {
			spaceKey,
			contentId,
			skipContent,
		},
		// Must be preloaded with network only to get fresh data
		fetchPolicy: 'network-only',
	});
}
